import { apiProxyRequest } from "Api/apiProxyRequest";

export type UserVerificationType = "credit-card";

export type UserVerificationPayload = {
  type: UserVerificationType;
  // Stripe payment method token (pm_*) obtained from the card setup intent.
  token: string;
};

export const postUserVerification = (
  userId: string,
  payload: UserVerificationPayload
) => apiProxyRequest<void>(`/users/${userId}/verification`, "POST", payload);
